import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizEntryBank;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import { Alert } from '@instructure/ui-alerts';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import Bank from '../../../../../../common/records/Bank';
import QuizEntry from '../../../../../../common/records/QuizEntry';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
export var QuizEntryBank = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizEntryBank = /*#__PURE__*/function (_Component) {
  function QuizEntryBank() {
    _classCallCheck(this, QuizEntryBank);
    return _callSuper(this, QuizEntryBank, arguments);
  }
  _inherits(QuizEntryBank, _Component);
  return _createClass(QuizEntryBank, [{
    key: "renderSampleError",
    value: function renderSampleError() {
      return jsx("div", {
        css: this.props.styles.alertWrapper
      }, jsx(Alert, {
        variant: "error"
      }, jsx(Text, {
        color: "primary"
      }, jsx("b", null, t('Max number of bank questions exceeded! ')), t("{ number, plural,\n                  one {This bank contains 1 question.}\n                  other {This bank contains # questions.}\n                } ", {
        number: this.props.entry.itemEntryCount
      }))));
    }
  }, {
    key: "renderDeletedError",
    value: function renderDeletedError() {
      return jsx("div", {
        css: this.props.styles.alertWrapper
      }, jsx(Alert, {
        variant: "error"
      }, jsx(Text, {
        color: "primary"
      }, t('Item bank no longer exists!'))));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var _this$props = this.props,
        entry = _this$props.entry,
        quizEntry = _this$props.quizEntry;
      if (entry.archived) {
        return this.renderDeletedError();
      }
      if (quizEntry.selection === 'rand' && quizEntry.sampleNum > entry.itemEntryCount) {
        return this.renderSampleError();
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var sampleNum = this.props.quizEntry.sampleNum;
      if (!sampleNum) sampleNum = 0;
      return jsx("div", {
        css: this.props.styles.quizEntryBankText
      }, jsx(Text, {
        color: "primary"
      }, t("{ number, plural,\n                =0 { All questions pulled from bank: }\n                one {# question pulled randomly from bank: }\n                other {# questions pulled randomly from bank: }\n              } ", {
        number: sampleNum
      }), jsx("b", null, this.props.entry.title), jsx("br", null), t("{ number, plural,\n                one {# point per question }\n                other {# points per question }\n              }", {
        number: this.props.quizEntry.pointsPossible
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.quizEntryBank
      }, jsx(View, {
        size: "medium",
        textAlign: "center",
        margin: "0 auto",
        padding: "small"
      }, this.renderErrors(), this.renderContent()));
    }
  }]);
}(Component), _defineProperty(_QuizEntryBank, "displayName", 'QuizEntryBank'), _defineProperty(_QuizEntryBank, "componentId", "Quizzes".concat(_QuizEntryBank.displayName)), _defineProperty(_QuizEntryBank, "propTypes", {
  entry: PropTypes.instanceOf(Bank).isRequired,
  quizEntry: PropTypes.instanceOf(QuizEntry).isRequired,
  styles: PropTypes.object
}), _QuizEntryBank)) || _class);
export default QuizEntryBank;